/**
 * Coups de pouce — Attendu 1084 « Reconnaître si une situation donnée entre
 * dans le cadre de la proportionnalité ou non ».
 *
 * Entrée PARTAGÉE par les trois formats de jugement (situations_tableau_vf,
 * situations_classer, reperer_qcm_unique) : même tâche, même méthode — les
 * DEUX TESTS du corrigé de la fiche n°46 (« je double : l'autre double-t-elle ?
 * à 0 correspond-il 0 ? »). L'exemple (revue 2026-09-01) est HORS des 24
 * variantes du gen : le jus à 2 € le verre (passe les deux tests) et le
 * bowling 6 € + 3 € la partie (échoue aux deux) — l'étape 4 attaque
 * frontalement l'obstacle P11 « ça augmente ensemble donc c'est
 * proportionnel ». SVG pas à pas piloté par les flèches de la sheet
 * (data-etapes / data-caption, mécanisme 2026-08-21).
 *
 * logique_tableau_vf : PAS d'entrée (pur rappel, doctrine gen_640) — chaque
 * ligne EST une connaissance sur le modèle, toute aide utile la donnerait.
 * tableau_qcm_unique : entrée dédiée séparée (données chiffrées).
 */

const SVG_DEUX_TESTS = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 374" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="4"
     aria-label="Les deux tests, sur deux situations, en 4 étapes à faire défiler avec les flèches. Situation A, le jus de fruits à 2 euros le verre : 1 verre 2 euros, 2 verres 4 euros. Je double les verres : le prix double. Et pour 0 verre, on paie 0 euro : proportionnel. Situation B, le bowling : 6 euros les chaussures puis 3 euros la partie : 1 partie 9 euros, 2 parties 12 euros. Je double les parties : 9 euros ne double pas, 12 euros et pas 18. Et pour 0 partie, on paie déjà 6 euros : pas proportionnel. Le prix augmente pourtant avec le nombre de parties : augmenter ensemble ne suffit pas">
  <style>
    @keyframes cp1084-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1084-pop { opacity: 0; animation: cp1084-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Situation A : le jus de fruits, 2 € le verre</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Le prix double ✓ et pour 0 verre : 0 € ✓</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Situation B : le bowling, 6 € puis 3 € la partie</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="4" font-family="system-ui,sans-serif">9 € ne double pas ✗ et pour 0 partie : déjà 6 € ✗</text>

  <!-- ── Situation A : tableau (étape 1) ─────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <text x="8" y="44" font-size="12.5" font-weight="700" fill="#111827">A. Le jus : 2 € le verre</text>
    <rect x="80" y="56" width="200" height="52" fill="#ffffff" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="170" y1="56" x2="170" y2="108" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="225" y1="56" x2="225" y2="108" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="80" y1="82" x2="280" y2="82" stroke="#94a3b8" stroke-width="1.4"/>
    <text x="125" y="74" font-size="12.5" fill="#111827" text-anchor="middle">Verres</text>
    <text x="197.5" y="74" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">1</text>
    <text x="252.5" y="74" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">2</text>
    <text x="125" y="100" font-size="12.5" fill="#111827" text-anchor="middle">Prix</text>
    <text x="197.5" y="100" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">2 €</text>
    <text x="252.5" y="100" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">4 €</text>
  </g>

  <!-- ── Les deux tests sur A (étape 2) ──────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1084-pop">
      <path d="M 197.5 52 C 210 40 240 40 252.5 52" fill="none" stroke="#1E3A8A" stroke-width="2.2"/>
      <path d="M 252.5 52 l -8 -2 l 3 -7 Z" fill="#1E3A8A"/>
      <text x="225" y="38" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">×2</text>
      <path d="M 197.5 112 C 210 124 240 124 252.5 112" fill="none" stroke="#1D9E75" stroke-width="2.2"/>
      <path d="M 252.5 112 l -8 2 l 3 7 Z" fill="#1D9E75"/>
      <text x="225" y="138" font-size="12" font-weight="800" fill="#1D9E75" text-anchor="middle">×2 ✓</text>
      <text x="8" y="161" font-size="12.5" font-weight="700" fill="#1D9E75">Pour 0 verre : 0 € ✓</text>
      <rect x="232" y="146" width="120" height="22" rx="8" fill="#ecfdf5" stroke="#1D9E75"/>
      <text x="292" y="161" font-size="11.5" font-weight="800" fill="#1D9E75" text-anchor="middle">Proportionnel</text>
    </g>
  </g>

  <!-- ── Situation B : tableau (étape 3) ─────────────────────────────── -->
  <g data-etape="3" font-family="system-ui,sans-serif">
    <text x="8" y="192" font-size="12.5" font-weight="700" fill="#111827">B. Le bowling : 6 € + 3 € la partie</text>
    <rect x="80" y="204" width="200" height="52" fill="#ffffff" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="170" y1="204" x2="170" y2="256" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="225" y1="204" x2="225" y2="256" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="80" y1="230" x2="280" y2="230" stroke="#94a3b8" stroke-width="1.4"/>
    <text x="125" y="222" font-size="12.5" fill="#111827" text-anchor="middle">Parties</text>
    <text x="197.5" y="222" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">1</text>
    <text x="252.5" y="222" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">2</text>
    <text x="125" y="248" font-size="12.5" fill="#111827" text-anchor="middle">Prix</text>
    <text x="197.5" y="248" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">9 €</text>
    <text x="252.5" y="248" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">12 €</text>
  </g>

  <!-- ── Les deux tests sur B (étape 4) ──────────────────────────────── -->
  <g data-etape="4" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1084-pop">
      <path d="M 197.5 200 C 210 188 240 188 252.5 200" fill="none" stroke="#1E3A8A" stroke-width="2.2"/>
      <path d="M 252.5 200 l -8 -2 l 3 -7 Z" fill="#1E3A8A"/>
      <text x="225" y="186" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">×2</text>
      <path d="M 197.5 260 C 210 272 240 272 252.5 260" fill="none" stroke="#B45309" stroke-width="2.2" stroke-dasharray="5 4"/>
      <path d="M 252.5 260 l -8 2 l 3 7 Z" fill="#B45309"/>
      <text x="225" y="286" font-size="12" font-weight="800" fill="#B45309" text-anchor="middle">12 €, pas 18 € ✗</text>
      <text x="8" y="311" font-size="12.5" font-weight="700" fill="#B45309">Pour 0 partie : déjà 6 € ✗</text>
      <rect x="224" y="296" width="128" height="22" rx="8" fill="#fffbeb" stroke="#B45309"/>
      <text x="288" y="311" font-size="11.5" font-weight="800" fill="#B45309" text-anchor="middle">Pas proportionnel</text>
      <rect x="20" y="328" width="320" height="30" rx="10" fill="#eff6ff" stroke="#bfdbfe"/>
      <text x="180" y="347" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Ça augmente ensemble, et pourtant : NON.</text>
    </g>
  </g>

  <text x="180" y="371" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

/*
 * Exemple tableau_qcm_unique (revue 2026-09-01) : stylos à 4,20 € l'unité —
 * AU-DESSUS du plafond du gen (prix unitaire max 3,45 €), donc ces valeurs
 * ne peuvent sortir d'aucun tirage, aucune branche. L'étape 4 rejoue le même
 * geste sur un prix truqué (30,00 €) : l'élève voit le doublement trancher
 * dans les DEUX sens, sans qu'on touche à son tableau à lui.
 */
const SVG_DOUBLEMENT = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 316" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="4"
     aria-label="Le geste du doublement, en 4 étapes à faire défiler avec les flèches. Un tableau : pour 2 stylos on paie 8 euros 40, pour 4 stylos 16 euros 80, pour 8 stylos 33 euros 60. Les quantités doublent. De 2 à 4 : 8 euros 40 plus 8 euros 40 égale 16 euros 80, le prix double. De 4 à 8 : 16 euros 80 plus 16 euros 80 égale 33 euros 60, le prix double encore : proportionnel, le prix pour un seul ne change pas. Et si, pour 8 stylos, on avait payé 30 euros ? Ce n’est pas le double de 16 euros 80 : pas proportionnel, le prix pour un seul change">
  <style>
    @keyframes cp1084b-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1084b-pop { opacity: 0; animation: cp1084b-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">2, 4, 8 stylos : les quantités doublent</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">De 2 à 4 : 8,40 + 8,40 = 16,80 ✓</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="3" font-family="system-ui,sans-serif">De 4 à 8 : 16,80 + 16,80 = 33,60 ✓</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="4" font-family="system-ui,sans-serif">30,00 € pour 8 ? Ce n’est pas le double ✗</text>

  <!-- ── Le tableau (étape 1) ────────────────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <rect x="40" y="56" width="290" height="52" fill="#ffffff" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="130" y1="56" x2="130" y2="108" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="196" y1="56" x2="196" y2="108" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="262" y1="56" x2="262" y2="108" stroke="#94a3b8" stroke-width="1.4"/>
    <line x1="40" y1="82" x2="330" y2="82" stroke="#94a3b8" stroke-width="1.4"/>
    <text x="85" y="74" font-size="12.5" fill="#111827" text-anchor="middle">Stylos</text>
    <text x="163" y="74" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">2</text>
    <text x="229" y="74" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">4</text>
    <text x="296" y="74" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">8</text>
    <text x="85" y="100" font-size="12.5" fill="#111827" text-anchor="middle">Prix</text>
    <text x="163" y="100" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">8,40 €</text>
    <text x="229" y="100" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">16,80 €</text>
    <text x="296" y="100" font-size="12.5" font-weight="700" fill="#111827" text-anchor="middle">33,60 €</text>
  </g>

  <!-- ── Premier doublement, 2 → 4 (étape 2) ─────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1084b-pop">
      <path d="M 163 52 C 176 40 216 40 229 52" fill="none" stroke="#1E3A8A" stroke-width="2.2"/>
      <path d="M 229 52 l -8 -2 l 3 -7 Z" fill="#1E3A8A"/>
      <text x="196" y="38" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">×2</text>
      <path d="M 163 112 C 176 124 216 124 229 112" fill="none" stroke="#1D9E75" stroke-width="2.2"/>
      <path d="M 229 112 l -8 2 l 3 7 Z" fill="#1D9E75"/>
      <text x="196" y="138" font-size="12" font-weight="800" fill="#1D9E75" text-anchor="middle">×2 ✓</text>
      <text x="8" y="160" font-size="12.5" font-weight="700" fill="#1D9E75">8,40 + 8,40 = 16,80 ✓</text>
    </g>
  </g>

  <!-- ── Deuxième doublement, 4 → 8 (étape 3) ────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1084b-pop">
      <path d="M 229 52 C 242 40 283 40 296 52" fill="none" stroke="#1E3A8A" stroke-width="2.2"/>
      <path d="M 296 52 l -8 -2 l 3 -7 Z" fill="#1E3A8A"/>
      <text x="262" y="38" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">×2</text>
      <path d="M 229 112 C 242 124 283 124 296 112" fill="none" stroke="#1D9E75" stroke-width="2.2"/>
      <path d="M 296 112 l -8 2 l 3 7 Z" fill="#1D9E75"/>
      <text x="262" y="138" font-size="12" font-weight="800" fill="#1D9E75" text-anchor="middle">×2 ✓</text>
      <text x="8" y="178" font-size="12.5" font-weight="700" fill="#1D9E75">16,80 + 16,80 = 33,60 ✓</text>
      <rect x="20" y="190" width="320" height="26" rx="10" fill="#ecfdf5" stroke="#1D9E75"/>
      <text x="180" y="207" font-size="11.5" font-weight="800" fill="#1D9E75" text-anchor="middle">Proportionnel : le prix pour un seul ne change pas</text>
    </g>
  </g>

  <!-- ── Le contre-exemple, prix truqué (étape 4) ────────────────────── -->
  <g data-etape="4" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1084b-pop">
      <text x="8" y="240" font-size="12.5" font-weight="700" fill="#111827">Et si, pour 8 stylos, on avait payé 30,00 € ?</text>
      <text x="8" y="260" font-size="12.5" font-weight="700" fill="#B45309">16,80 + 16,80 = 33,60, pas 30,00 ✗</text>
      <rect x="20" y="272" width="320" height="26" rx="10" fill="#fffbeb" stroke="#B45309"/>
      <text x="180" y="289" font-size="11.5" font-weight="800" fill="#B45309" text-anchor="middle">Pas proportionnel : le prix pour un seul change</text>
    </g>
  </g>

  <text x="180" y="313" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_TABLEAU = {
    pages: [
        {
            titre: 'Le geste du doublement',
            lignes: [
                '**Les quantités doublent** d\'une colonne à la suivante. Vérifie les prix : **doublent-ils aussi, à chaque fois ?**',
                'Pour doubler un prix de tête : je l\'ajoute à lui-même.',
                'Les prix doublent à chaque fois : le prix pour un seul ne change pas, c\'est **proportionnel**.',
                'Un seul prix ne double pas : le prix pour un seul change, ce n\'est **pas proportionnel**.',
            ],
        },
        { titre: 'Un exemple : le tableau des stylos', svg: SVG_DOUBLEMENT },
    ],
};

const AIDE_SITUATIONS = {
    pages: [
        {
            titre: 'Les deux tests',
            lignes: [
                '**Je double l\'une : l\'autre double-t-elle ?** Dans une situation proportionnelle, oui, toujours.',
                '**À 0 correspond 0.** Sans rien acheter, on ne paie rien : s\'il reste quelque chose à payer (un forfait, des frais fixes), ce n\'est pas proportionnel.',
                '**Un seul test raté suffit** pour répondre : pas proportionnel.',
            ],
        },
        { titre: 'Un exemple : deux situations', svg: SVG_DEUX_TESTS },
    ],
};

const CP_1084 = {
    situations_tableau_vf: AIDE_SITUATIONS,
    situations_classer: AIDE_SITUATIONS,
    reperer_qcm_unique: AIDE_SITUATIONS,
    tableau_qcm_unique: AIDE_TABLEAU,
    // logique_tableau_vf : volontairement ABSENT (pur rappel, cf. en-tête).
};

export default CP_1084;
